"use client";
import React from "react";
import { useAppDispatch } from "appHooks";
import { toggleTheme } from "features/config/config.reducer";
import { useTranslation } from "hooks/useTranslation";
import styles from "./ThemeSwitcher.module.css";

const ThemeSwitcher: React.FC = () => {
  const dispatch = useAppDispatch();
  const t = useTranslation();

  const handleToggle = () => {
    dispatch(toggleTheme());
  };

  return (
    <i
      className={styles['theme-switcher']}
      onClick={handleToggle}
      role="button"
      title={t("header.toggleTheme")}
      aria-label={t("header.toggleTheme")}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleToggle();
        }
      }}
    />
  );
};

export default ThemeSwitcher;
